module.exports = __webpack_public_path__ + "b199ca49cb94f5670e5b8f9525f59f20.png";